import { render, staticRenderFns } from "./Clnsadmin.vue?vue&type=template&id=c6fe4a9a&scoped=true"
import script from "./Clnsadmin.vue?vue&type=script&lang=js"
export * from "./Clnsadmin.vue?vue&type=script&lang=js"
import style0 from "./Clnsadmin.vue?vue&type=style&index=0&id=c6fe4a9a&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fe4a9a",
  null
  
)

export default component.exports